import axios from "axios";
import { sendMultipartFilePost } from "../utils/multipart-helper";

// new
const requestObituaryMessageList = obituaryMessage => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/admin/obituaryMessage/obituaryMessage-page`,
    obituaryMessage
  );
};

const requestUpdateObituaryMessage = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/admin/obituaryMessage/update`,
    parameter
  );
};

const requestDeleteObituaryMessage = obituaryMessageId => {
  return axios.put(
    `${process.env.VUE_APP_APIURL}/api/admin/obituaryMessage/delete`,
    obituaryMessageId
  );
};

export {
  requestUpdateObituaryMessage,
  requestObituaryMessageList,
  requestDeleteObituaryMessage
};
